import Cookies from 'js-cookie'

/**
 * Dono do cookie de sessão da NexAtlas. O cookie é de domínio `.nexatlas.com`, ou seja, é compartilhado
 * com o app legado (`app.nexatlas.com`) — um login/logout de lá rotaciona o token por baixo de uma aba
 * aberta do planning-app. Por isso o token nunca deve ser tratado como imutável depois do boot.
 */
export const AUTH_COOKIE_NAME = '_nat'
export const AUTH_COOKIE_DOMAIN = '.nexatlas.com'

export function readAuthCookie(): string | null {
  return Cookies.get(AUTH_COOKIE_NAME) ?? null
}
